export default {
      id: "cycling_outdoor-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#cycling_outdoor",
      toString: function () {
        return this.url;
      }
    }